module.exports = __webpack_public_path__ + "img/serie-a.16e7af99.png";